import React from "react";
import '../styles/HeaderFooterReport.css';

const FooterReport = () => {
  return (
    <footer className="report-footer">
      <hr />
      <p>Teléfonos: Quito 0990653327 - 0986858353  </p>
    </footer>
  );
};

export default FooterReport;
